var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSoftwareDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "web_development",
    "data-name": "web development",
    transform: "translate(-529 -181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    width: 32,
    height: 32,
    transform: "translate(529 181)",
    fill: "rgba(0,0,0,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "web-development",
    transform: "translate(531 183)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 2,
    cy: 1,
    rx: 2,
    ry: 1,
    transform: "translate(11.792 16.792)",
    fill: "#f13733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M12.255,92.873a.808.808,0,0,1-.672.36H0v18.695a.808.808,0,0,0,.808.808H26.776a.808.808,0,0,0,.808-.808V90H14.171Zm3.961,3.646v1.06a5.863,5.863,0,0,1,1.042.6l.92-.531a.808.808,0,0,1,1.1.3l1.616,2.8a.808.808,0,0,1-.3,1.1l-.915.529a5.974,5.974,0,0,1,0,1.209l.915.529a.808.808,0,0,1,.3,1.1l-1.616,2.8a.808.808,0,0,1-1.1.3l-.92-.531a5.862,5.862,0,0,1-1.042.6v1.06a.808.808,0,0,1-.808.808H12.176a.808.808,0,0,1-.808-.808v-1.06a5.864,5.864,0,0,1-1.042-.6l-.92.531a.808.808,0,0,1-1.1-.3l-1.616-2.8a.808.808,0,0,1,.3-1.1l.915-.529a5.973,5.973,0,0,1,0-1.209l-.915-.529a.808.808,0,0,1-.3-1.1l1.616-2.8a.808.808,0,0,1,1.1-.3l.92.531a5.862,5.862,0,0,1,1.042-.6v-1.06a.808.808,0,0,1,.808-.808h3.232A.808.808,0,0,1,16.216,96.519Z",
    transform: "translate(0 -85.151)",
    fill: "#f13733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M159.073,228.532l-.7-.4-.808,1.4.693.4a.808.808,0,0,1,.388.862,4.354,4.354,0,0,0,0,1.734.808.808,0,0,1-.388.862l-.693.4.808,1.4.7-.4a.808.808,0,0,1,.94.1,4.279,4.279,0,0,0,1.5.866.808.808,0,0,1,.553.767v.8h1.616v-.8a.808.808,0,0,1,.553-.767,4.279,4.279,0,0,0,1.5-.866.808.808,0,0,1,.94-.1l.7.4.808-1.4-.693-.4a.808.808,0,0,1-.388-.862,4.352,4.352,0,0,0,0-1.734.808.808,0,0,1,.388-.862l.693-.4-.808-1.4-.7.4a.808.808,0,0,1-.94-.1,4.278,4.278,0,0,0-1.5-.866.808.808,0,0,1-.553-.767V226h-1.616v.8a.808.808,0,0,1-.553.767,4.279,4.279,0,0,0-1.5.866A.808.808,0,0,1,159.073,228.532Zm3.8.162a2.963,2.963,0,1,1-2.963,2.963A2.966,2.966,0,0,1,162.87,228.694Z",
    transform: "translate(-149.078 -213.824)",
    fill: "#f13733"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M26.776,0H.808A.808.808,0,0,0,0,.808V6.465H11.151l1.915-2.873a.808.808,0,0,1,.672-.36H27.584V.808A.808.808,0,0,0,26.776,0ZM4.041,4.041a.808.808,0,1,1,.808-.808A.808.808,0,0,1,4.041,4.041Zm3.232,0a.808.808,0,1,1,.808-.808A.808.808,0,0,1,7.273,4.041Zm3.232,0a.808.808,0,1,1,.808-.808A.808.808,0,0,1,10.506,4.041Z",
    fill: "#f13733"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDevelopment);
export default __webpack_public_path__ + "static/media/software_development.04b457de4ca28f2dcc69bf66b22f5478.svg";
export { ForwardRef as ReactComponent };